import styled from 'styled-components'

export const Container = styled.div`
	flex: 1;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	font-size: 18px;
	line-height: 22px;
`

const Button = styled.div`
	flex: 1;
	text-align: center;
	border-radius: 7px;
	padding: 13px 0;
	
	:hover {
		opacity: 0.7;
	};
	transition: 300ms ease;
`

export const ConfirmButton = styled(Button)`
	background-color: #CBE1EA;	
	margin-right: 5%;
	
	&.disabled {
		opacity: 0.3;
		pointer-events: none;
	}
`

export const CancelButton = styled(Button)`
	background-color: #EACBCB;	
`
